import React from 'react';

export default function SectionIcon({ color = 'gray', size = 28, children, style }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `var(--sec-${color})`,
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
